import { Commit, Dispatch } from 'vuex';
import pushService, { Unbinder } from '@/general/services/PushService';
import { parseMoment } from '@/shared/converters/dateConverters';
import { OutletId } from '@/shared/models/Outlet';
import { present } from '@/shared/utils/typescript';
import { parsePlannerEvent, parsePlannerEvents } from '../converters/plannerEventConverters';
import { parseUnplannedEventUpdate } from '../converters/unplannedEventUpdateConverters';

const plannerUnbinds: Array<Unbinder> = [];

async function createPlannedEvent(data: any, commit: Commit, dispatch: Dispatch): Promise<void> {
  const event = present(parsePlannerEvent(data));
  commit('addPlannedEvent', event);
  await dispatch('refreshPlannerResources');
}

function createUnplannedEvent(data: any, commit: Commit): void {
  const event = present(parsePlannerEvent(data));
  commit('addUnplannedEvent', event);
}

async function updateEvent(data: any, commit: Commit, dispatch: Dispatch): Promise<void> {
  switch (data.action) {
    case 'RESCHEDULE':
      commit('rescheduleEvents', present(parsePlannerEvents(data.events)));
      await dispatch('refreshPlannerResources');
      break;
    case 'PAUSED':
      // ToDo, het volledige event object zou moeten worden meegegven
      commit('pauseEvent', { eventId: data.id });
      break;
    case 'STOPPED':
      // ToDo, het volledige event object zou moeten worden meegegven
      commit('stopEvent', data.id);
      break;
    case 'STATUS': {
      commit('updateEventStatus', { eventId: data.id, vehicleStatus: data.objectStatus, workStatus: data.workStatus });
      break;
    }
    case 'EDITABLE':
      commit('updateEventEditable', { eventId: data.id, editable: data.isEditable });
      break;
    case 'DELETE':
      commit('deletePlannedEvent', data.id);
      await dispatch('refreshPlannerResources');
      break;
    case 'UPDATE':
      commit('updateEvent', present(parsePlannerEvent(data.plannedWork)));
      break;
    case 'PAUSESTATUS':
      data.events.forEach((d: any) => {
        const payload = { eventId: d.id, isPaused: d.isMechanicPaused };
        commit('updateIsMechanicPaused', payload);
      });
      break;
  }
}

function closeDay(data: any, commit: Commit): void {
  if (data.action !== 'STOPPED') {
    // eslint-disable-next-line no-console
    console.warn('unexpected action', data.action);
    return;
  }
  const date = parseMoment(data.closedDay);
  if (!date) {
    // eslint-disable-next-line no-console
    console.warn('invalid date', data.closedDay);
    return;
  }
  commit('closeDay', date);
}

function updateUnplannedEvent(data: any, commit: Commit): void {
  commit('updateUnplannedEvent', parseUnplannedEventUpdate(data));
}

export function startPlannerPush(outletId: OutletId, commit: Commit, dispatch: Dispatch): void {
  stopPlannerPush();
  // TODO the additional JSON.parse calls shouldn't be needed - is something wrong at the back-end?
  const unbindUpdateEvent = pushService.bind(`workshopplanning-${outletId}/event-update`, data => updateEvent(data, commit, dispatch));
  const unbindCreatePlannedEvent = pushService.bind(`workshopplanning-${outletId}/event-create`, data => createPlannedEvent(JSON.parse(data), commit, dispatch));
  const unbindCreateUnplannedEvent = pushService.bind(`workshopplanning-${outletId}/offplanning-event-create`, data => createUnplannedEvent(JSON.parse(data), commit));
  const unbindCloseDay = pushService.bind(`workshopplanning-${outletId}/planning-closed`, data => closeDay(JSON.parse(data), commit));
  const unbindUpdateOffPlanningEvent = pushService.bind(`workshopplanning-${outletId}/update-unplanned-event`, data => updateUnplannedEvent(data, commit));
  plannerUnbinds.push(unbindUpdateEvent, unbindCreatePlannedEvent, unbindCreateUnplannedEvent, unbindCloseDay, unbindUpdateOffPlanningEvent);
}

export function stopPlannerPush(): void {
  pushService.unbind(plannerUnbinds);
  plannerUnbinds.splice(0);
}
